/* eslint-disable @typescript-eslint/naming-convention */
import { BaseModel } from '../core/abstractions/base.model';
import { GateActionTypeEnum } from './enums/gate-action-type.enum';

export class GateLogModel extends BaseModel {
    success: boolean;
    timeStamp: Date;
    actionType: GateActionTypeEnum;
    shareholderIdOrBarcode?: string;
    message?: string;

    constructor(init?: Partial<GateLogModel>) {
        super();
        Object.assign(this, init);
    }
}
